import 'css-chunksrc/client/common/projectsSelection/search/styles.scss';export default {
  "search": "_search_c7egg_1"
};